import { createSlice } from '@reduxjs/toolkit';

const initialAutoSettleState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    autoSettleForEdit: undefined,
    lastError: null,
};

export const callTypes = {
    list: 'list',
    action: 'action',
};

export const autoSettleSlice = createSlice({
    name: 'autoSettle-notification',
    initialState: initialAutoSettleState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
                state.actionsLoading = false;
            } else {
                state.listLoading = false;
                state.actionsLoading = true;
            }
        },

        // getAutoSettleById
        autoSettleFetched: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.autoSettle = action.payload.autoSettle;
        },
        // findAutoSettle
        autoSettlesFetched: (state, action) => {
            const { total_items, items } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = items;
            state.totalCount = total_items;
        },
        // Set to default state actionLoading & error
        autoSettleReload: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.error = null;
        },

    },
});

